import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Step, Direction } from '@app/core/models/step';
import { TranslatedService } from '@app/shared/services/translated.service';

@Component({
	selector: 'g-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnChanges {
	@Input() steps: Step[] = [];
	@Input() selectedStep?: Step;
	@Input() allowSelectAnyStep = false;
	@Input() canAccessNextStep = true;
	@Input() revertableStepKeys: string[] = [];
	@Output() readonly onStepChange = new EventEmitter<{
		step: Step;
		direction: Direction;
	}>();
	selectedStepIndex = 0;

	constructor(public translated: TranslatedService) {}

	/** Lifecycle hook that is called when any data-bound property of the component changes. */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.steps || changes.selectedStep) {
			this.updateStepIndex();
		}
	}

	/** Initializes the component. */
	ngOnInit(): void {
		this.updateStepIndex();
	}

	onSelectStep = (step: Step, stepIndex: number): void => {
		if (step === this.selectedStep) return;
		if (!this.allowSelectAnyStep && stepIndex >= this.selectedStepIndex + 2) {
			return; // Only allow selecting the next step
		}
		if (!this.canAccessNextStep && stepIndex > this.selectedStepIndex) return;
		if (!this.revertableStepKeys.includes(step.key) && stepIndex < this.selectedStepIndex) return;
		const direction = stepIndex > this.selectedStepIndex ? Direction.Next : Direction.Previous;
		this.selectedStep = step;
		this.selectedStepIndex = stepIndex;
		this.onStepChange.emit({ step, direction });
	};

	/** Updates the selected step index based on the current selected step. */
	private updateStepIndex(): void {
		if (this.selectedStep) {
			this.selectedStepIndex = Math.max(this.steps.indexOf(this.selectedStep), 0);
		} else {
			this.selectedStepIndex = 0;
			this.selectedStep = this.steps?.[0];
		}
	}
}
